import { lazy } from 'react';

const TreasuryTrade = lazy(() => import('../pages/TreasuryTrade/List'));
const PayableToEmployees = lazy(() =>
  import('../pages/Treasury/PayableToEmployees'),
);
const PayableToVendors = lazy(() =>
  import('../pages/Treasury/PayableToVendors'),
);

const treasuryRoute = {
  public: [],
  auth: [
    {
      name: 'treasury',
      path: '/treasury/trade/:status?',
      component: TreasuryTrade,
    },
    {
      name: 'payable_to_employees',
      path: '/treasury/payable-to-employees',
      component: PayableToEmployees,
    },
    {
      name: 'payable_to_vendors',
      path: '/treasury/payable-to-vendors',
      component: PayableToVendors,
    },
  ],
};

export default treasuryRoute;
